// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"292":"360e41e4","326":"82cc1c8b","572":"90bbf2a1","834":"4be57edb"}[chunkId] + ".chunk.css";
};